module.exports = __webpack_public_path__ + "fonts/Graphik-SuperItalic.d03cec79.woff";